import React from 'react';
import ContactHelp from './ContactHelp';

const Error404 = (props) => {

  return (
    <>
      <div className="error404">
        <div className="error404__content-container">
          <h2>Page not found</h2>
          <p>Sorry, this page does not exist. Please check the address bar and try again.</p>
          <a href="/telluswhoyouare" className="arrow-link">
              <span className="left">&#xFFEA;</span>Go to start
          </a>
        </div>
      </div>
      <ContactHelp />
    </>
  )
}

export default Error404;